import {
  CreateContentWrapper,
  CreateGoback,
  CreateLinkBigContainer,
  CreateLinkSubHeader,
  CreateLinkText,
  HorizontalLine,
} from "../CreatePaymentLink/CreatePaymentLink.styles";
import { useNavigate } from "react-router-dom";
import { environment } from "../../env";
import { GET_ALL_PRODUCTS_BY_ORGANIZATION_ID } from "../../graphql/queries/paymentlink";
import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { WrapperStyle } from "../../template/AccountBalance";
import fipayFonts from "../../theme/index";
import { colors } from "../../theme/color";

const ProductList = () => {
  const { loading, error, data } = useQuery(
    GET_ALL_PRODUCTS_BY_ORGANIZATION_ID,
    {
      variables: {
        ...environment.paymentLinkService,
        payload: {
          limit: 10,
          page: 1,
        },
      },
    }
  );

  const navigate = useNavigate();
  const NavigateBackPaymentLink = () => {
    navigate("/dashboard/payment-link");
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <CreateLinkBigContainer>
      <CreateContentWrapper>
        <CreateLinkSubHeader>
          <img
            src="/assets/svg/goBack.svg"
            alt=""
            onClick={NavigateBackPaymentLink}
          />
          <CreateGoback>Go back</CreateGoback>
        </CreateLinkSubHeader>
        <CreateLinkText>Products</CreateLinkText>
      </CreateContentWrapper>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <WrapperStyle>
          <ProductLinkHeader>
            <Title>List of All Products</Title>
          </ProductLinkHeader>
          <HorizontalLine />
          <ProductHeader>
            <HeaderItem style={{ flex: "0 0 50px" }}>No.</HeaderItem>
            <HeaderItem style={{ flex: "0 0 95px" }}>Image</HeaderItem>
            <HeaderItem style={{ flex: 1 }}>Name</HeaderItem>
            <HeaderItem style={{ flex: 1 }}>Price</HeaderItem>
            <HeaderItem style={{ flex: 2, textAlign: "center" }}>
              Description
            </HeaderItem>
          </ProductHeader>
          {data?.getAllProductsByOrganizationId?.data.map(
            (product: any, index: any) => (
              <ProductItem key={product.id}>
                <ProductNumber style={{ flex: "0 0 50px" }}>
                  {index + 1}
                </ProductNumber>
                <ProductImage
                  src={product.images}
                  alt={product.name}
                  style={{ flex: "0 0 120px" }}
                />
                <ProductDetails>
                  <ProductName>{product.name}</ProductName>
                  <ProductPrice>${product.price}</ProductPrice>
                  <ProductDescription>{product.description}</ProductDescription>
                </ProductDetails>
              </ProductItem>
            )
          )}
        </WrapperStyle>
      </div>
    </CreateLinkBigContainer>
  );
};

export default ProductList;

// Styled components
const ProductHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 10px;
  font-weight: bold;
`;

const HeaderItem = styled.div`
  padding: 0 20px;
`;

const ProductItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 10px;
  margin-bottom: 20px;
  margin-right: 20px;
`;

const ProductNumber = styled.div`
  text-align: center;
`;

const ProductImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-right: 40px;
  margin-left: 20px;
`;

const ProductDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
`;

const ProductName = styled.div`
  flex: 1;
  font-size: 18px;
  font-weight: 400;
  color: #0e0e0e;
`;

const ProductPrice = styled.div`
  flex: 1;
  font-size: 16px;
  color: #09005b;
  margin: 5px 40px;
  padding-left: 10px;
`;

const ProductDescription = styled.div`
  flex: 2;
  font-size: 14px;
  color: gray;
  text-align: center;
`;

const ProductLinkHeader = styled.div`
  width: 100%;
  height: 32px;
  padding: 10px;
`;

const Title = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
  color: ${colors.PURPLE};
`;
